import React from "react";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import CheckCircle from "@material-ui/icons/CheckCircle";
import PropTypes from "prop-types";

const styles = (theme) => ({
  successPanel: {
    width: "700px",
    textAlign: "center",
  },
  refNumber: {
    marginBottom: theme.spacing(4),
  },
  button: {
    marginLeft: "10px",
    "&:first-child": {
      marginLeft: 0,
    },
  },
  successIcon: {
    fontSize: "80px",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
});

const CreateWorkItemSuccess = (props) => {
  const {
    createdWorkItem,
    workItemTypes,
    classes,
    originLink,
    originLinkLabel,
    itemLink,
    template,
  } = props;
  const typeDisplay = `${template ? "Repeating " : ""}${
    workItemTypes.values[createdWorkItem.type].description
  }`;

  return (
    <Grid container alignItems="center" direction="row" justifyContent="center">
      <Paper style={{ padding: 24 }} elevation={0}>
        <div className={classes.successPanel}>
          <Typography variant="h4" data-cy={typeDisplay}>
            The {typeDisplay} has been created.
          </Typography>
          <CheckCircle className={classes.successIcon} />
          <Typography
            className={classes.refNumber}
            variant="body1"
            data-cy="Reference Number:"
          >
            Reference Number: {createdWorkItem.friendlyId}
          </Typography>
          <div>
            <Button
              className={classes.button}
              component={Link}
              to={itemLink}
              variant="contained"
              color="primary"
              size="large"
              data-cy={typeDisplay}
            >
              View {typeDisplay}
            </Button>
            <Button
              className={classes.button}
              component={Link}
              to={originLink}
              variant="contained"
              color="default"
              size="large"
              data-cy="returnToDashboard"
            >
              {originLinkLabel}
            </Button>
          </div>
        </div>
      </Paper>
    </Grid>
  );
};

CreateWorkItemSuccess.propTypes = {
  createdWorkItem: PropTypes.object.isRequired,
  workItemTypes: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  originLink: PropTypes.string.isRequired,
  originLinkLabel: PropTypes.string.isRequired,
  itemLink: PropTypes.string.isRequired,
  template: PropTypes.bool,
};

CreateWorkItemSuccess.defaultProps = {
  template: false,
};

export default withStyles(styles)(CreateWorkItemSuccess);
